import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import routes from './routes/routes';
import PrivateRoute from './routes/PrivateRoute';
import DashboardLayout from './layout/DashboardLayout';
import usePostLoginBootstrap from './hooks/usePostLoginBootstrap';
import { fetchCurrentUser, clearUser, selectUser, selectExpiresIn } from './redux/authSlice';
import { useSessionManager } from './hooks/useSessionManager';

const BASE_URL = process.env.REACT_APP_BASE_API_URL;

const ProtectedRouteWithLayout = ({ children }) => {
  usePostLoginBootstrap();
  return (
    <PrivateRoute>
      <DashboardLayout>{children}</DashboardLayout>
    </PrivateRoute>
  );
};

const resizeObserverError = window.onerror;
window.onerror = (msg, ...args) => {
  if (msg.includes('ResizeObserver loop')) return true;
  return resizeObserverError?.(...args);
};

function App() {
  const dispatch = useDispatch();
  const BASENAME = process.env.REACT_APP_BASENAME || "/dev/console";
  const user = useSelector(selectUser);
  const expiresIn = useSelector(selectExpiresIn);

  useEffect(() => {
    dispatch(fetchCurrentUser());
  }, [dispatch]);

  useSessionManager({
    expiresInSeconds: user ? expiresIn : null, // only run timer when logged in
    onExpired: () => {
      dispatch(clearUser());
      window.location.href = `${BASE_URL}/mvapi-ui/auth/logout`;
    },
  });

  const active = useSelector(s => s.globalData.activeAccountId);
  useEffect(() => {
    console.log('[activeAccountId]', active);
  }, [active]);

  return (
    <Router basename={BASENAME}>
      <Routes>
        {routes.map(({ path, element, protected: isProtected }) => (
          <Route
            key={path}
            path={path}
            element={
              isProtected ? (
                <ProtectedRouteWithLayout>{element}</ProtectedRouteWithLayout>
              ) : (
                element
              )
            }
          />
        ))}
      </Routes>
    </Router>
  );
}

export default App;